const TOPSON_STANDARD_ACCESSORIES = [
  { name: "หน้ากาก", quantity: "1 ชุด" },
  { name: "ท่อแรงดันอากาศ", quantity: "1 เส้น" },
  { name: "กระเป๋าอุปกรณ์", quantity: "1 ใบ" },
  { name: "AC/DC Power Supply Adapter", quantity: "1 ชุด" },
  { name: "คู่มือ", quantity: "1 เล่ม" },
  { name: "SD CARD", quantity: "1 ชิ้น" },
];

const TOPSON_PLUS_ACCESSORIES = [
  { name: "หน้ากาก", quantity: "1 ชุด" },
  { name: "ท่อแรงดันอากาศ", quantity: "1 เส้น" },
  { name: "กระปุกน้ำทำความชื้น", quantity: "1 ชุด" },
  { name: "กระเป๋าอุปกรณ์", quantity: "1 ใบ" },
  { name: "AC/DC Power Supply Adapter", quantity: "1 ชุด" },
  { name: "คู่มือ", quantity: "1 เล่ม" },
  { name: "SD CARD", quantity: "1 ชิ้น" },
];

const WELLELL_ACCESSORIES = [
  { name: "หน้ากาก", quantity: "1 ชุด" },
  { name: "ท่อเเรงดันอากาศ", quantity: "1 เส้น" },
  { name: "กระเป๋าอุปกรณ์", quantity: "1 ใบ" },
  { name: "สายไฟ", quantity: "1 เส้น" },
  { name: "คู่มือ", quantity: "1 เล่ม" },
  { name: "Filter Pack", quantity: "1 แพค" },
  { name: "สาย USB", quantity: "1 เส้น" },
  { name: "SD CARD", quantity: "1 ชิ้น" },
];

const RESMED_AIRMINI_ACCESSORIES = [
  { name: "ชุดหน้ากากสำหรับ AirMini", quantity: "1 ชุด" },
  { name: "ท่อแรงดันอากาศ", quantity: "1 เส้น" },
  { name: "AC/DC Power Supply Adapter", quantity: "1 เส้น" },
  { name: "คู่มือ", quantity: "1 เล่ม" },
];

const RESMED_AIRSENSE10_ACCESSORIES = [
  { name: "หน้ากาก", quantity: "1 ชุด" },
  { name: "ท่อแรงดันอากาศ", quantity: "1 เส้น" },
  { name: "กระปุกน้ำทำความชื้น", quantity: "1 กระปุก" },
  { name: "กระเป๋าอุปกรณ์", quantity: "1 ใบ" },
  { name: "AC/DC Power Supply Adapter", quantity: "1 ชุด" },
  { name: "คู่มือ", quantity: "1 เล่ม" },
  { name: "SD CARD", quantity: "1 ชิ้น" },
];

const RESMED_AIRSENSE11_ACCESSORIES = [
  { name: "หน้ากาก", quantity: "1 ชุด" },
  { name: "ท่อแรงดันอากาศ", quantity: "1 เส้น" },
  { name: "กระปุกน้ำทำความชื้น", quantity: "1 กระปุก" },
  { name: "กระเป๋าอุปกรณ์", quantity: "1 ใบ" },
  { name: "AC/DC Power Supply Adapter", quantity: "1 ชุด" },
  { name: "คู่มือ", quantity: "1 เล่ม" },
];

const VENTMED_ACCESSORIES = [
  { name: "หน้ากาก", quantity: "1 ชุด" },
  { name: "ท่อแรงดันอากาศ", quantity: "1 เส้น" },
  { name: "กระปุกน้ำทำความชื้น", quantity: "1 กระปุก" },
  { name: "กระเป๋าอุปกรณ์", quantity: "1 ใบ" },
  { name: "AC/DC Power Supply Adapter", quantity: "1 ชุด" },
  { name: "Filter Pack", quantity: "1 แพ็ค" },
  { name: "คู่มือ", quantity: "1 เล่ม" },
  { name: "SD CARD", quantity: "1 ชิ้น" },
];

const PHILIPS_DREAMSTATION_ACCESSORIES = [
  { name: "หน้ากาก", quantity: "1 ชุด" },
  { name: "ท่อแรงดันอากาศ", quantity: "1 เส้น" },
  { name: "กระเป๋าอุปกรณ์", quantity: "1 ใบ" },
  { name: "AC/DC Power Supply Adapter", quantity: "1 ชุด" },
  { name: "คู่มือ", quantity: "1 เล่ม" },
  {
    name: "Disposable Ultra-Fine Filter (แผ่นกรองละเอียด)",
    quantity: "1 ชิ้น",
  },
  {
    name: "Disposable Pollen Filter (แผ่นกรอง ใส่ไว้ในเครื่อง)",
    quantity: "1 ชิ้น",
  },
  { name: "SD CARD", quantity: "1 ชิ้น" },
];

// The values mirror the package-specific worksheets in
// "อุปกรณ์ประกอบ เครื่อง CPAP.xlsx". This configuration is intentionally
// used only by PDF export; it does not change order items or stock handling.
const SALE_PACKAGE_ACCESSORIES = {
  Wellell: WELLELL_ACCESSORIES,
  "Topson Standard": TOPSON_STANDARD_ACCESSORIES,
  "Topson Plus": TOPSON_PLUS_ACCESSORIES,
  "ResMed - Airmini": RESMED_AIRMINI_ACCESSORIES,
  "ResMed - AirMini": RESMED_AIRMINI_ACCESSORIES,
  ResMed: RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirStart": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirStart10 Standard Package": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirStart10 Premium Package": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirSense10 AutoSet / AutoSet FH": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirSense10 AutoSet": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirSense10 AutoSet For Her": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirSense10 Elite": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirSense10 Elite Standard Package": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirSense10 Elite Premium Package": RESMED_AIRSENSE10_ACCESSORIES,
  "ResMed - AirSense11 AutoSet": RESMED_AIRSENSE11_ACCESSORIES,
  "VentMed Standard": VENTMED_ACCESSORIES,
  "VentMed Premium": VENTMED_ACCESSORIES,
  "Philips - DreamStation Auto": PHILIPS_DREAMSTATION_ACCESSORIES,
  "Philips - DreamStation Auto With Humidifier": PHILIPS_DREAMSTATION_ACCESSORIES,
  "Philips - DreamStation Pro": PHILIPS_DREAMSTATION_ACCESSORIES,
};

export const getSalePackageAccessories = (salePackage) => {
  const accessories = SALE_PACKAGE_ACCESSORIES[salePackage];
  return accessories ? accessories.map((accessory) => ({ ...accessory })) : [];
};

export default SALE_PACKAGE_ACCESSORIES;
